import classNames from 'clsx';
import React, { useCallback } from 'react';
import { Helmet } from 'react-helmet-async';

import styles from './ReCaptcha.scss';

declare global {
  interface Window {
    recaptchaCallback(token: string): void;
    tokenExpiredCallback(): void;
  }
}

interface Props {
  siteKey: string;
  errorMessage?: string;
  recaptchaToken: string;
  setRecaptchaToken(value: string): void;
}

const ReCaptcha: React.FC<Props> = ({
  siteKey,
  errorMessage,
  recaptchaToken,
  setRecaptchaToken
}) => {
  const recaptchaCallback = useCallback(
    (token: string) => {
      setRecaptchaToken(token);
    },
    [setRecaptchaToken]
  );

  const tokenExpiredCallback = useCallback(() => {
    setRecaptchaToken('');
  }, [setRecaptchaToken]);

  return (
    <>
      <Helmet
        script={[
          {
            type: 'text/javascript',
            src: 'https://www.google.com/recaptcha/api.js',
            async: true
          },
          {
            type: 'text/javascript',
            content: `
              ${(window.recaptchaCallback = recaptchaCallback)};
              ${(window.tokenExpiredCallback = tokenExpiredCallback)};
            `
          }
        ]}
      />
      <div
        className={classNames(styles.recaptcha, 'g-recaptcha')}
        data-callback="recaptchaCallback"
        data-expired-callback="tokenExpiredCallback"
        data-sitekey={siteKey}
      />
      {!recaptchaToken && errorMessage && <p className={styles.recaptchaError}>{errorMessage}</p>}
    </>
  );
};

export default ReCaptcha;
